module.exports = __webpack_public_path__ + "assets/img/b4-6.761e9a80.png";